import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var TypeInfoClass;
function TypeInfo() {
  if (TypeInfoClass === VOID) {
    class $ {
      constructor(type, isNullable, kotlinType) {
        kotlinType = kotlinType === VOID ? null : kotlinType;
        this.o4w_1 = type;
        this.p4w_1 = isNullable;
        this.q4w_1 = kotlinType;
        var tmp;
        if (this.p4w_1) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = this.q4w_1;
          tmp = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1()) === true);
        }
        // Inline function 'kotlin.require' call
        if (!tmp) {
          var message = 'TypeInfo for nullable kotlinType ' + toString(this.q4w_1) + ' must have isNullable set to true';
          throw IllegalArgumentException().o2(toString_0(message));
        }
      }
      hashCode() {
        var tmp0_safe_receiver = this.q4w_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        return imul(31, tmp1_elvis_lhs == null ? this.o4w_1.hashCode() : tmp1_elvis_lhs) + getBooleanHashCode(this.p4w_1) | 0;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TypeInfo()))
          return false;
        if (!(this.p4w_1 === other.p4w_1))
          return false;
        var tmp;
        if (!(this.q4w_1 == null) || !(other.q4w_1 == null)) {
          tmp = equals(this.q4w_1, other.q4w_1);
        } else {
          tmp = this.o4w_1.equals(other.o4w_1);
        }
        return tmp;
      }
      toString() {
        var tmp0_elvis_lhs = this.q4w_1;
        return 'TypeInfo(' + toString_0(tmp0_elvis_lhs == null ? this.o4w_1 : tmp0_elvis_lhs) + ')';
      }
    }
    initMetadataForClass($, 'TypeInfo');
    TypeInfoClass = $;
  }
  return TypeInfoClass;
}
//region block: exports
export {
  TypeInfo as TypeInfo2nbxsuf4v8os2,
};
//endregion

//# sourceMappingURL=Type.mjs.map
